<template>
  <div class="position-absolute" style="margin: 10px; bottom: 0; right: 0; z-index: 999">
    <v-card rounded="sm">
      <v-btn
        color="surface"
        rounded="sm"
        density="compact"
        icon
        :aria-label="$t('googleMaps.zoomIn')"
        style="min-width: 32px; min-height: 32px"
        @click="emit('zoom-in')"
      >
        <v-icon icon="add" />
      </v-btn>

      <v-divider />

      <v-btn
        color="surface"
        rounded="sm"
        density="compact"
        icon
        :aria-label="$t('googleMaps.zoomOut')"
        style="min-width: 32px; min-height: 32px"
        @click="emit('zoom-out')"
      >
        <v-icon icon="remove" />
      </v-btn>
    </v-card>
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: "zoom-in" | "zoom-out"): void
}>()
</script>
